<template>
  <InvoiceDetail
    :s-invoice-id="$route.params.idInvoice"
    @back="$router.go(-1)"
  />
</template>

<script>
import InvoiceDetail from "./InvoiceDetail.vue";

export default {
  name: "InvoiceView",
  components: {
    InvoiceDetail,
  },
};
</script>
